import React from 'react';
import { useForm } from 'react-hook-form';
import { AuthContextType } from '../../../features/auth/AuthContext';
import { updateUserPassword } from '../../../api/account';

interface UserPasswordInput {
    current_password: string;
    new_password: string;
    new_password_confirm: string;
}

interface UserPasswordFormProps {
    auth: AuthContextType;
}

const UserPasswordForm: React.FC<UserPasswordFormProps> = ({ auth }) => {
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
    const [processMessage, setProcessMessage] = React.useState<string | null>(null);
    const [successMessage, setSuccessMessage] = React.useState<string | null>(null);

    const { register, handleSubmit, reset } = useForm<UserPasswordInput>({
        defaultValues: {
            current_password: '',
            new_password: '',
            new_password_confirm: '',
        },
    });

    const onSubmit = (data: UserPasswordInput) => {
        setErrorMessage(null);
        setSuccessMessage(null);
        if (data.new_password !== data.new_password_confirm) {
            setErrorMessage('신규 비밀번호가 일치하지 않습니다.');
            return;
        }
        updateUserPassword({
            auth,
            payload: {
                current_password: data.current_password,
                new_password: data.new_password,
                new_password_confirm: data.new_password_confirm,
            },
            setErrorMessage,
            setProcessMessage,
            setSuccessMessage,
            setResult: () => {
                reset({
                    current_password: '',
                    new_password: '',
                    new_password_confirm: '',
                });
            },
        });
    };

    return (<>
        {errorMessage && (
            <div className="alert alert-danger" role="alert">
                {errorMessage}
            </div>
        )}
        {processMessage && (
            <div className="alert alert-info" role="alert">
                {processMessage}
            </div>
        )}
        {successMessage && (
            <div className="alert alert-success" role="alert">
                {successMessage}
            </div>
        )}

        <div className="col-6">
            <ul className="list-unstyled">
                <li className="mb-3">
                    <label className="form-label">기존 비밀번호</label>
                    <input
                        type="password"
                        className="form-control"
                        {...register('current_password')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">신규 비밀번호</label>
                    <input
                        type="password"
                        className="form-control"
                        {...register('new_password')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">신규 비밀번호 확인</label>
                    <input
                        type="password"
                        className="form-control"
                        {...register('new_password_confirm')}
                    />
                </li>
            </ul>
            <div className="d-flex gap-2">
                <button type="button" className="btn btn-primary" onClick={handleSubmit(onSubmit)}>
                    비밀번호 변경
                </button>
            </div>
        </div>
    </>);
};

export default UserPasswordForm;
